<template>
  <article>
    <section class="container">
      <h1>抱歉，此議程不提供議程線上討論區！</h1>
    </section>
  </article>
</template>

<script>
  export default {
    name: 'Venue'
  }
</script>

<style lang="sass" scoped>
article
  section
    h1
      margin-top: 30vh
      text-align: center
      font-size: 36px
</style>



// WEBPACK FOOTER //
// src/pages/NoSlido.vue